import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { Text } from "@ps-design-system/components/Text";

import {
  TAX_INFORMATION_STATUSES,
  TAX_INFORMATION_TYPES,
} from "../tax-information.constants";

import { getStatusBannerMeta } from "./TaxInformationStatusBanner.utils";

const TaxInformationStatusBanner = ({
  taxInformationId,
  taxInformationStatus,
}) => {
  const { icon, title, message, containerClassName } = getStatusBannerMeta(
    taxInformationStatus,
    taxInformationId,
  );

  return (
    <div
      className={classnames(
        "tw-p-8 tw-rounded-2 tw-border",
        containerClassName,
      )}
    >
      <div className="tw-flex tw-flex-col tw-gap-4">
        <div className="tw-flex tw-items-center tw-gap-8">
          <span>{icon}</span>
          <Text typeface="body-2-m">{title}</Text>
        </div>
        <Text typeface="caption-2" className="tw-text-gray-600">
          {message}
        </Text>
      </div>
    </div>
  );
};

TaxInformationStatusBanner.propTypes = {
  taxInformationId: PropTypes.oneOf(Object.values(TAX_INFORMATION_TYPES)),
  taxInformationStatus: PropTypes.oneOf(
    Object.values(TAX_INFORMATION_STATUSES),
  ),
};

export { TaxInformationStatusBanner };
